export const iconFontAwesomeFilesFilePen = (
	<i className="fa-solid fa-file-pen"></i>
);
